import {
  ListSCCareRecordsRequest,
  ListSCCareRecordsResponse,
  ListSCCareTemplatesRequest,
  ListSCCareTemplatesResponse,
  ProvisionSCCareOrgRequest,
  ProvisionSCCareOrgResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/workflows_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "../types";

export type ProvisionSCCareOrgParams = {
  emailAddress: string;
  firstName: string;
  lastName: string;
  orgName: string;
  policyNumber: string;
  country: string;
  state: string;
  postalCode: string;
  currency: string;
  brokerEmail: string;
  sendWelcomeEmail: boolean;
  templateIds: string[];
};

export const provisionSCCareOrg = async (
  params: ProvisionSCCareOrgParams,
  headers: Record<RequestMetadata, string>,
): Promise<ProvisionSCCareOrgResponse> => {
  const req = new ProvisionSCCareOrgRequest(params);
  return supportServiceConnectClient.provisionSCCareOrg(req, { headers });
};

export const listSCCareRecords = async (
  headers: Record<RequestMetadata, string>,
): Promise<ListSCCareRecordsResponse> => {
  const req = new ListSCCareRecordsRequest();
  return supportServiceConnectClient.listSCCareRecords(req, { headers });
};

export const listSCCareTemplates = async (
  headers: Record<RequestMetadata, string>,
): Promise<ListSCCareTemplatesResponse> => {
  const req = new ListSCCareTemplatesRequest();
  return supportServiceConnectClient.listSCCareTemplates(req, { headers });
};
